<template>
	<div id="page" v-cloak>
		<nav class="trading_record_nav clear">
			<p v-for="(item,index) in type" :class="{ opt : (index+1) == present }" @click="navSelect((index+1),item.code)">{{item.value}}</p>
		</nav>
		<ul class="trading_record_class clear">
			<li>时间</li>
			<li>收支项目</li>
			<li>金额</li>
		</ul>
		<mescroll-vue ref="mescroll" :up="mescrollUp" @init="mescrollInit">
			<ul class="trading_record_list">
				<li class="clear" v-for="item in dataList">
					<p>{{item.Time}}</p>
					<p>{{item.Desc}}</p>
					<p>{{item.Amount}}<span>{{present==3?'元':'个'}}</span></p>
				</li>
			</ul>
			<div id="warpId"></div>
		</mescroll-vue>
	</div>
</template>

<script>
	import MescrollVue from 'mescroll.js/mescroll.vue'
	export default {
		name: 'ProfitDetails',
		components: {
			MescrollVue // 注册mescroll组件
		},
		data() {
			return {
				userId: '',
				H5Key: '',
				md5: '',
				type: [
					{'value': '钻石','code': 1},
				    {'value': '银币','code': 2},
				    {'value': '现金','code': 3},
			    ],
				present: 1,
				mescroll: null, // mescroll实例对象
				mescrollUp: { // 上拉加载的配置.
					callback: this.upCallback,
					htmlNodata: '<p class="upwarp-nodata">-- 已经到底了 --</p>',
					toTop: {
						//回到顶部按钮
						src: "http://dig-mineral.yeedian365.com/taobao_union/img/mescroll-totop.png", //图片路径,默认null,支持网络图
						offset: 1000 //列表滚动1000px才显示回到顶部按钮
					},
					empty: {
						//列表第一页无任何数据时,显示的空提示布局; 需配置warpId才显示
						warpId: "warpId", //父布局的id (1.3.5版本支持传入dom元素)
						icon: "http://dig-mineral.yeedian365.com/taobao_union/img/mescroll-empty.png", //图标,默认null,支持网络图
						tip: "暂无相关数据~" //提示
					}
				},
				dataList: [],
			}
		},
		mounted() {
			if(window.LaiaJs){
				window.LaiaJs.setTitle('收支明细');
				this.userId = window.LaiaJs.getUserId();
				this.H5Key = window.LaiaJs.getH5Key();
				this.md5 = this.$md5(this.userId+'&'+this.H5Key);
			}else{
				this.userId = '090405e138b74c9f9ceb397f42633c06';
				this.H5Key = 'PyPtPu4qSx1wTBYEYB4ASyWETrVsSBPv';
				this.md5 = this.$md5(this.H5Key);
			}
		},
		methods: {
			mescrollInit(mescroll) {
				this.mescroll = mescroll // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
			},
			upCallback(page, mescroll) {
				//联网请求
				this.$axios.post("my/getUserCoinsMoneyDiamondsRecord.do", {
					"user_id": this.userId,
					"type": this.present,
					"page_no": page.num,
					"sign": this.md5,
				}).then((res) => {
					// console.log(res);
					if(res.data.Error != ""){
						if(window.LaiaJs){
							window.LaiaJs.showMsg(res.data.Error);
							return;
						}else{
							alert(res.data.Error);
							return;
						}
					}
					//请求的列表数据
					var list = res.data.RecordList;
					var str = "";
					if (page.num == 1) this.dataList = [];
					//把请求到的数据添加到列表
					this.dataList = this.dataList.concat(list);
					//数据渲染成功后,隐藏下拉刷新的状态
					this.$nextTick(() => {
						this.mescroll.endSuccess(list.length);
					})
				}).catch((e) => {
					//联网失败的回调,隐藏下拉刷新和上拉加载的状态;
					this.mescroll.endErr();
				})
			},
			// 分类搜索
			navSelect(index, code) {
				if (index == this.present) {
					return;
				}
				this.present = index;
				this.dataList = [];
				this.mescroll.setPageNum(1);
				this.mescroll.triggerUpScroll();
			},
		}
	}
</script>

<style scoped>
	[v-cloak] {
		display: none;
	}
	#page {
		width: 100%;
		height: 100vh;
		background-color: #eaf1f7;
	}
	.mescroll {
		position: fixed;
		width: 100%;
		height: auto;
		top: 2.16rem;
		bottom: 0;
	}
	.trading_record_nav {
		width: 100%;
		font-size: 0.4rem;
		text-align: center;
		font-weight: bold;
		color: #3672f9;
		border-bottom: 1px solid #dddfe4;
		background-color: #fff;
	}

	.trading_record_nav p {
		width: 33.333%;
		height: 1.2rem;
		line-height: 1.2rem;
		float: left;
	}

	.trading_record_nav .opt {
		color: #fff;
		background-color: #3672f9;
	}

	.trading_record_class,
	.trading_record_list li {
		width: 100%;
		height: 0.94rem;
		line-height: 0.94rem;
		font-size: 0.38rem;
		text-align: center;
		color: #3e4854;
		background-color: #dee2ff;
	}

	.trading_record_class li,
	.trading_record_list li p {
		width: 33.333%;
		height: 0.94rem;
		line-height: 0.94rem;
		float: left;
	}

	.trading_record_list li {
		color: #868a8e;
		background-color: #fff;
		font-size: 0.3rem;
		border-bottom: 0.02rem solid #dddfe4;
	}
</style>



// WEBPACK FOOTER //
// src/pages/TradingRecord.vue